import PasswordContent from './PasswordContent'

export default PasswordContent
